import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_190_bill_wise_release_add: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Bill Release",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "bill_wise_release",
        TableName: "bill_wise_release",
        Plugins: [{ type: "api", module: "all" }],
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        fieldVisibilityRules: [
          {
            when: { field: "drp_voucher_type", label: "Invoice" },
            showFields: [
              "drp_voucher_invoice",
              "bill_wise_release_payment_sources",
            ],
          },
          {
            when: { field: "drp_voucher_type", label: "Receipt" },
            showFields: ["drp_voucher_receipt", "bill_wise_release_invoice"],
          },
        ],
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Bill release details",
            BindValue: "con_bill_wise_release_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_customer",
                label: "Customer name",
                placeholder: "Select customer",
                required: true,
                lookupName: "customers",
                options: [],
                Json_Attribute: "customer_id",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Customer name is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_voucher_type",
                label: "Voucher type",
                placeholder: "Select voucher type",
                required: true,
                defaultValue: "receipt_voucher",
                options: [
                  { value: "sales_invoice", label: "Invoice" },
                  { value: "receipt_voucher", label: "Receipt" },
                ],
                Json_Attribute: "voucher_type",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Voucher type is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_voucher_invoice",
                label: "List of voucher",
                placeholder: "Select invoice",
                required: true,
                lookupName: "customer_bill_release_customer_invoices",
                parentField: "drp_customer",
                options: [],
                Json_Attribute: "document_id",
                validation: [
                  {
                    rule: ValidationRule.CONDITIONAL_REQUIRED,
                    whenField: "drp_voucher_type",
                    whenValue: "sales_invoice",
                    message: "Invoice is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_voucher_receipt",
                label: "List of voucher",
                placeholder: "Select receipt",
                required: true,
                lookupName: "customer_bill_release_customer_receipts",
                parentField: "drp_customer",
                options: [],
                Json_Attribute: "document_id",
                validation: [
                  {
                    rule: ValidationRule.CONDITIONAL_REQUIRED,
                    whenField: "drp_voucher_type",
                    whenValue: "receipt_voucher",
                    message: "Receipt is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "bill_release_voucher_parent",
                label: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "bill_release_voucher_parent",
                BindValue: "bill_release_voucher_parent",
                showInSummary: false,
                style: { display: "none" },
                BindParent: {
                  drp_voucher_invoice: "id",
                  drp_voucher_receipt: "id",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_document_no",
                label: "Document No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "document_no",
                disabled: true,
                BindValue: "document_no",
                BindParent: {
                  drp_voucher_invoice: "invoice_no",
                  drp_voucher_receipt: "document_no",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_document_type",
                label: "Document type",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "document_type",
                disabled: true,
                BindValue: "document_type",
                BindParent: {
                  drp_voucher_type: "value",
                },
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "bill_wise_release_invoice",
            label: "Invoice release details",
            billWiseReleaseInvoiceMode: true,
            tableName: "bill_wise_release_invoice_split",
            lookupName: "customer_bill_release_invoices_by_voucher",
            parentField: "bill_release_voucher_parent",
            DisableAddNewRow: true,
            enableDeleteAction: true,
            BindValue: "bill_wise_release_invoice_split",
            childControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_invoice_no",
                label: "Invoice No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "invoice_no",
                disabled: true,
                BindValue: "txt_invoice_no",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_due_amount",
                label: "Due amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "due_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_due_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount_paid",
                label: "Paid amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount_paid",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_amount_paid",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_allocation_link_id",
                label: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "allocation_link_id",
                BindValue: "allocation_link_id",
                IsHidden: true,
                showInSummary: false,
                style: { display: "none" },
                disabled: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_release_amount",
                label: "Release amount",
                placeholder: "",
                required: true,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount",
                defaultValue: "0",
                BindValue: "txt_release_amount",
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[txt_release_amount] > 0",
                    message: "Release amount must be greater than zero",
                  },
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[txt_release_amount] <= [txt_amount_paid]",
                    message: "Release amount cannot exceed paid amount",
                  },
                ],
              },
            ],
            FooterControls: [
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_amount",
                Json_Attribute: "net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_release_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[net_amount] > 0",
                    message: "Amount must be greater than zero",
                  },
                ],
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "bill_wise_release_payment_sources",
            label: "Invoice release details",
            billWiseReleaseInvoiceMode: true,
            tableName: "bill_wise_release_payment_sources_split",
            lookupName: "customer_bill_release_sources_by_invoice",
            parentField: "bill_release_voucher_parent",
            DisableAddNewRow: true,
            enableDeleteAction: true,
            BindValue: "bill_wise_release_payment_sources_split",
            childControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_source_voucher_no",
                label: "Voucher / Receipt No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "source_voucher_no",
                disabled: true,
                BindValue: "txt_source_voucher_no",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_source_type",
                label: "Type",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "source_type_label",
                disabled: true,
                BindValue: "txt_source_type",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount_paid",
                label: "Paid amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount_paid",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_amount_paid",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_invoice_no",
                label: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "invoice_no",
                BindValue: "txt_invoice_no",
                IsHidden: true,
                showInSummary: false,
                style: { display: "none" },
                disabled: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_allocation_link_id",
                label: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "allocation_link_id",
                BindValue: "allocation_link_id",
                IsHidden: true,
                showInSummary: false,
                style: { display: "none" },
                disabled: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_entry_source",
                label: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "entry_source",
                BindValue: "entry_source",
                IsHidden: true,
                showInSummary: false,
                style: { display: "none" },
                disabled: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_release_amount",
                label: "Release amount",
                placeholder: "",
                required: true,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount",
                defaultValue: "0",
                BindValue: "txt_release_amount",
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[txt_release_amount] > 0",
                    message: "Release amount must be greater than zero",
                  },
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[txt_release_amount] <= [txt_amount_paid]",
                    message: "Release amount cannot exceed paid amount",
                  },
                ],
              },
            ],
            FooterControls: [
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_amount",
                Json_Attribute: "net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_release_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[net_amount] > 0",
                    message: "Amount must be greater than zero",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
